import { insert, pickAll, without } from 'ramda'

export const handleDataLayerEvent = id => {
  window.dataLayer.push({
    event: `search-filter-${id}`
  })
}

export const disableBedrooms = (unit_types = []) => {
  return unit_types.length === 1 && unit_types.includes('SINGLE')
}

export const updateUnitTypeFilters = (id, unit_types = [], updateFilters) => {
  const unitTypesFilter = unit_types.includes(id)
    ? without([id], unit_types)
    : insert(0, id, unit_types)

  const clearHousingTypes =
    !unitTypesFilter.includes('ENTIRE') && !unitTypesFilter.includes('SINGLE')
  const clearUnitSubTypes = !unitTypesFilter.includes('PARTIAL')
  const clearBedrooms =
    unitTypesFilter.length === 1 && unitTypesFilter.includes('SINGLE')

  return updateFilters({
    unit_types: unitTypesFilter,
    ...(clearUnitSubTypes && { unit_subtypes: [] }),
    ...(clearHousingTypes && { housing_types: [] }),
    ...(clearBedrooms && { bedroom_count: [] })
  })
}

export const getFilterValues = filters =>
  pickAll(
    [
      'housing_types',
      'unit_types',
      'unit_subtypes',
      'bedroom_count',
      'bathroom_count',
      'pet_policy',
      'min_price',
      'max_price',
      'availability_date',
      'custom_availability_date',
      'search_only_verified',
      'sort',
      'min_size',
      'lease_type',
      'rental_type',
      'has_3d_tour',
      'features',
      'utilities',
      'deals',
      'distance',
      'transportation'
    ],
    filters
  )
